import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "creditAccountField", "debitAccountField", "feeField", "currencyRateField", "sumToAddField"]

  adjust_fields(event) {
    const creditAccountFieldHidden = this.creditAccountFieldTarget.classList.contains("hidden");
    const debitAccountFieldHidden = this.debitAccountFieldTarget.classList.contains("hidden");
    const feeFieldHidden = this.feeFieldTarget.classList.contains("hidden");
    const currencyRateFieldHidden = this.currencyRateFieldTarget.classList.contains("hidden");
    const sumToAddFieldHidden = this.sumToAddFieldTarget.classList.contains("hidden");


    switch(event.target.value) {
      case "income":
        if (!creditAccountFieldHidden) this.creditAccountFieldTarget.classList.add("hidden");
        if (debitAccountFieldHidden) this.debitAccountFieldTarget.classList.remove("hidden");
        if (!feeFieldHidden) this.feeFieldTarget.classList.add("hidden");
        if (!currencyRateFieldHidden) this.currencyRateFieldTarget.classList.add("hidden");
        if (!sumToAddFieldHidden) this.sumToAddFieldTarget.classList.add("hidden");
        break;
      case "expense":
        if (creditAccountFieldHidden) this.creditAccountFieldTarget.classList.remove("hidden");
        if (!debitAccountFieldHidden) this.debitAccountFieldTarget.classList.add("hidden");
        if (feeFieldHidden) this.feeFieldTarget.classList.remove("hidden");
        if (!currencyRateFieldHidden) this.currencyRateFieldTarget.classList.add("hidden");
        if (!sumToAddFieldHidden) this.sumToAddFieldTarget.classList.add("hidden");
        break;
      case "transfer":
        if (creditAccountFieldHidden) this.creditAccountFieldTarget.classList.remove("hidden");
        if (debitAccountFieldHidden) this.debitAccountFieldTarget.classList.remove("hidden");
        if (feeFieldHidden) this.feeFieldTarget.classList.remove("hidden");
        if (currencyRateFieldHidden) this.currencyRateFieldTarget.classList.remove("hidden");
        if (sumToAddFieldHidden) this.sumToAddFieldTarget.classList.remove("hidden");
        break;
    }
  }
}
